app.component("profileMenu", {
	// Inlined rather than a templateUrl: this renders inside a hover-triggered nav popover, and a quick
	// mouse-out destroys the element before the template XHR resolves, aborting it (status -1) and
	// throwing $templateRequest:tpload. An inline template has nothing to fetch and nothing to abort.
	template:
		'<div>' +
		'<div ng-click="$ctrl.changeEmail()"><a class="head-link">Update Email</a></div>' +
		'<div ng-click="$ctrl.switchUser()" data-testid="nav-switch-user"><a class="head-link">Sign in as someone else</a></div>' +
		'<div ng-click="loginPopup()" ng-if="xeroEnabled && XeroStateReady && !isXeroLoggedIn">' +
		'<a class="head-link">Login Xero</a></div>' +
		'<div ng-click="logoutXero()" ng-if="xeroEnabled && XeroStateReady && isXeroLoggedIn">' +
		'<a class="head-link">Logout Xero</a></div>' +
		'</div>',
	controller: "profileMenuController",
	bindings: {
        changeEmail: "&",
        switchUser: "&",
	},
});

app.controller("profileMenuController", [
	"$scope",
    "$modal",
    "$window",
    "Session",
    "BillingAPI",
	function ($scope,$modal,$window, Session, BillingAPI) {

        this.$onInit = function () {
            $scope.xeroEnabled = Session.practice
                && Session.practice.practiceFeatures
                && Session.practice.practiceFeatures.billingFeature === true;
            $scope.BillingAPI = BillingAPI;
            $scope.isXeroLoggedIn = Session.xeroLogin === true;
            // Avoid prefetching billing auth on popover open; use cached session state instead.
            $scope.XeroStateReady = !$scope.xeroEnabled || Session.xeroLogin !== null;

            if ($scope.xeroEnabled && Session.xeroLogin === null) {
                $scope.XeroStateReady = true;
                $scope.isXeroLoggedIn = false;
            }
        }

        $scope.loginPopup = function (){
            $scope.loginInvoiceModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.invoice-login.tpl.html",
                show: true,
                backdrop: "static",
                keyboard: false,
            });
        }
    
        $scope.logoutXero = function (){
            $scope.BillingAPI.isProcessing = true;
            $scope.BillingAPI.logoutXero().then(function (resp) {
                $scope.isXeroLoggedIn = false;
                Session.setXeroLoginState(false);
            }, function () {
                // Not logged: the $http error carries the bearer token.
            }).then(function(){
                $scope.BillingAPI.isProcessing = false;
            });
            
        }
    
        $scope.loginXero = function () {
            if($scope.loginInvoiceModal){
                $scope.loginInvoiceModal.hide();
            }
            $scope.BillingAPI.isProcessing = true;
            $scope.BillingAPI.getXeroLoginUrl().then(function(resp){
                const xeroUrl = resp.data;
                $window.open(xeroUrl, "_blank", "location=no,toolbar=yes,scrollbars=yes,resizable=yes,top=200,left=500,width=500,height=600");
            },function(){
                // Not logged: the $http error carries the bearer token.
            }).then(function(){
                $scope.BillingAPI.isProcessing = false;
            })
        }
		
	},
]);
